import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from '../../../../../adapters/types'
import { RocFormData } from '../../../../types/RocFormData'
import { RocFormField } from '../../../../types/RocFormField'
import { RocAssessmentQuestionnaireItem } from '../../../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../../../helpers'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'

/**
 * Cardiac subsection adapter
 * Handles cardiovascular assessment and heart sounds (4 fields)
 */
export class CardiacAdapter extends BaseSubsectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Cardiac assessment fields
    const cardiacStatus = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL
    )?.at(0)

    const cardiacAbnormalFactors = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS
    )

    const heartSounds = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS
    )?.at(0)

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [RocFormField.CARDIAC_STATUS]: cardiacStatus,
      [RocFormField.CARDIAC_ABNORMAL_FACTORS]: cardiacAbnormalFactors,
      [RocFormField.CARDIAC_HEART_SOUNDS]: heartSounds,
      [RocFormField.CARDIAC_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RocFormField.CARDIAC_STATUS)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL,
        value: this.getFormDataField(RocFormField.CARDIAC_STATUS)
      })
    }

    if (this.formDataFieldExists(RocFormField.CARDIAC_ABNORMAL_FACTORS)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS,
        value: this.getFormDataField(RocFormField.CARDIAC_ABNORMAL_FACTORS)
      })
    }

    if (this.formDataFieldExists(RocFormField.CARDIAC_HEART_SOUNDS)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS,
        value: this.getFormDataField(RocFormField.CARDIAC_HEART_SOUNDS)
      })
    }

    if (this.formDataFieldExists(RocFormField.CARDIAC_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY,
        value: this.getFormDataField(RocFormField.CARDIAC_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
